import Matpel from "../../../../../components/categories/siakad/lms/data_matpel/Home";
export default function Home() {
  
  return (
    <Matpel />
  );
}
